import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { List, Avatar, Badge, Tooltip, Spin, Image, Modal } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CommonSelect from "../../../core/common/commonSelect";
import { Button, Checkbox, DatePicker, Drawer, message, Select, TimePicker, } from "antd";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { BuildAttendance, getEmployeeAttendanceByDate } from "../../../core/data/redux/attendance/punch/punchAction";
import dayjs from "dayjs";
import AttendanceSummaryCard from "./AttendanceSummaryCard";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV, exportToExcel, exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";
import { formatTimeOnly } from "../../../core/utils/formatTime";
import { usePunchCSVImport } from "../../../customhooks/useAttendanceCSVImport";
import { Row, Col } from "antd";
import { fetchAllattendanceReport } from "../../../core/data/redux/reports/attendance_report/attendacnereport.Action";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import { fetchAllProjects } from "../../../core/data/redux/projects/project/projectAction";
import { createBulkPunchIn } from "../../../core/data/redux/attendance/punch/punchAction";
import { Popover, Card } from "antd";
import { fetchEmployeeLocation } from "../../../core/data/redux/employee/employeeAction";
import RouteMapModal from "./trackLocationModal";
import { LocationPoint } from "../../../core/data/redux/employee/employeeTypes";
import { EnvironmentOutlined } from "@ant-design/icons"
import { Pagination } from "antd";
import { decryptData } from "../../../core/utils/encryptUtils";
import { getEmployeeShift } from "../../../core/data/redux/attendance/punch/punchAction";
import { getAddressFromLatLng } from "../../../core/utils/getAddressFromCoords";
import CheckInLocation from "./CheckInLocation";

interface AttendanceRecord {
  employee_id: number;
  name: string;
  department: string;
  project: string;
  punch_dates: string;
  leave_dates: string[];
  holidays?: string[];
}

interface FormattedAttendance extends Omit<AttendanceRecord, "punch_dates"> {
  punch_dates: string[];
  attendanceMap?: Record<string, string>; // key=date, value=status
}

interface Day {
  label: number;
  date: string;
  dayName: string;
}

interface CustomAttendanceTableProps {
  attendancelist: AttendanceRecord[];
  selectedMonth: string;
  selectedDept?: string;
  selectedProject?: string;
  selectedDay?: string | null;
  selectedEmployee?: any;
}
export interface Employee {
  EmployeeID: string;
  Name: string;
  EmployeeNumber: string;
  CheckedIn: any;
  EmployeePictureURL: string;
  LastLocation?: { Latitude: number | string; Longitude: number | string; timestamp: string };
}

interface EmployeeRecord {
  id: string;
  route: LocationPoint[];
  employeeId: any;
  record: any;


}
interface FetchEmployeeLocationResponse {
  payload: {
    locations: LocationPoint[];

  };
}

interface RouteMapModalProps {
  isOpen: boolean;
  onClose: () => void;
  route: LocationPoint[]; // Ensure LocationPoint is also defined
  isMapLoaded: boolean;
}




const AttendanceAdmin = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [tableKey, setTableKey] = useState(0);
  const { employeeAttendanceAnalytics } = useSelector((state: any) => state.attendance.punch);
  const [selectedStatus, setSelectedStatus] = useState("Present");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DD"));
  const { handleCSVImport } = usePunchCSVImport();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [showSampleModal, setShowSampleModal] = useState<any>(false);
  const [selectedDept, setSelectedDept] = useState<string | undefined>();
  const [selectedProject, setSelectedProject] = useState<string | undefined>();
  const { departments } = useSelector((state: any) => state.department);
  const [selectedMonth, setSelectedMonth] = useState<string>(dayjs().format("YYYY-MM"));
  const [attendanceState, setAttendanceState] = useState<{ [key: string]: string }>({});
  const [selectedEmployee, setSelectedEmployee] = useState<any>();
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const [employeeRoute, setEmployeeRoute] = useState<LocationPoint[]>([]);
  const [isFetchingRoute, setIsFetchingRoute] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | null>(null);
  const [isOpening, setIsOpening] = useState(false);
  const [isBuilding, setIsBuilding] = useState(false);
  const [isAddressModalVisible, setIsAddressModalVisible] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<string | null>(null);

  const handleAddressClick = (address: string | null) => {
    if (!address) return;
    setSelectedAddress(address);
    setIsAddressModalVisible(true);
  };

  const handleAddressModalClose = () => {
    setIsAddressModalVisible(false);
    setSelectedAddress(null);
  };
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyBJZaHef9KbOAfcdUTHv5osChzfHRc2ne0",
    libraries: ['maps'],
  });

  const handleOpenDrawer = () => {
    setIsOpening(true);
    setIsDrawerOpen(true);
  };


  useEffect(() => {
    if (!selectedEmployeeId) return;

    setIsFetchingRoute(true);
    setIsMapModalOpen(true);

    dispatch(fetchEmployeeLocation(selectedEmployeeId))
      .then((response: any) => {

        const locs = response.payload?.locations ?? [];


        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);


        const filteredLocs = locs.filter((loc: any) => {
          const locDate = new Date(loc.Timestamp);
          locDate.setHours(0, 0, 0, 0);
          return locDate.getTime() === currentDate.getTime();
        }).reverse();

        setEmployeeRoute(filteredLocs);
      })
      .catch((error) => {
        console.error("Error fetching employee location:", error);
        setEmployeeRoute([]);
      })
      .finally(() => setIsFetchingRoute(false));
  }, [selectedEmployeeId, dispatch]);

  const handleViewRoute = (record: any) => {
    setSelectedEmployeeId(record.EmployeeID);
    setIsMapModalOpen(true);
  };

  const triggerImportFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleBuildAttendance = () => {
    setIsBuilding(true);
    if (selectedMonth) {
      const month = dayjs(selectedMonth).format("MM");
      const year = dayjs(selectedMonth).format("YYYY");
      dispatch(BuildAttendance({ month, year }))
        .then((res: any) => {
          message.success(res.payload.message)
          dispatch(fetchAllattendanceReport()).then((res) => {
            setattendacnelist(res.payload.data);
          });
        })
        .finally(() => {
          setIsBuilding(false);
        });
    } else {
      console.log("No month selected!");
    }
  };




  const CustomAttendanceTable: React.FC<CustomAttendanceTableProps> = ({
    attendancelist,
    selectedMonth,
    selectedDept,
    selectedProject,
    selectedDay,
    selectedEmployee,
  }) => {

    const [daysInMonth, setDaysInMonth] = useState<Day[]>([]);
    const [originalCheckedState, setOriginalCheckedState] = useState<{ [key: string]: boolean; }>({});
    const [checkedState, setCheckedState] = useState<{ [key: string]: boolean; }>({});
    const [attendanceState, setAttendanceState] = useState<{ [key: string]: string }>({});
    const [timeState, setTimeState] = useState<{
      [key: string]: { [status: string]: { inTime?: string; outTime?: string } };
    }>({});
    const [open, setOpen] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 20;

    const dispatch = useDispatch<any>();



    const ATTENDANCE_OPTIONS = [
      { value: "present", label: "Present", color: "#4CAF50" },
      { value: "half_day", label: "Half_Day", color: "#2196F3" },
      { value: "holiday", label: "Holiday", color: "#2196F3" },
      { value: "absent", label: "Absent", color: "#F44336" },
      // { value: "Leave", label: "Leave", color: "#FF9800" },
      { value: "weekoff", label: "Weekoff", color: "#9C27B0" },
    ];

    const AttendanceCell = React.memo(
      ({
        empId,
        date,
        value,
        onChange,
      }: {
        empId: number;
        date: string;
        value?: string;
        onChange: (val: string) => void;
      }) => {
        const cellKey = `${empId}-${date}`;
        const [open, setOpen] = useState(false);
        const dispatch = useDispatch<any>();
        const [shiftData, setShiftData] = useState<{ StartTime?: string; EndTime?: string }>({});

        // 🔹 Safely handle dropdown open
        const handlePopoverChange = async (newOpen: boolean) => {
          setOpen(newOpen);

          if (newOpen) {
            // ✅ Check if data already exists — don’t re-fetch or override
            const existingTimes = timeState[cellKey]?.Present || timeState[cellKey]?.Half_Day;
            if (existingTimes?.inTime && existingTimes?.outTime) {
              // Already have shift data → don’t call API again
              return;
            }

            try {
              const res = await dispatch(getEmployeeShift({ date, employee: empId })).unwrap();
              const shift = res?.data?.[0];

              if (shift) {
                const newShift = {
                  StartTime: shift.StartTime || "",
                  EndTime: shift.EndTime || "",
                };
                setShiftData(newShift);

                // ✅ Only set if not already present
                setTimeState((prev) => {
                  const prevCell = prev[cellKey] || {};
                  const alreadyHasTimes =
                    prevCell?.Present?.inTime || prevCell?.Half_Day?.inTime;

                  if (alreadyHasTimes) return prev;

                  return {
                    ...prev,
                    [cellKey]: {
                      ...prevCell,
                      Present: {
                        ...(prevCell?.Present || {}),
                        inTime: newShift.StartTime,
                        outTime: newShift.EndTime,
                      },
                      Half_Day: {
                        ...(prevCell?.Half_Day || {}),
                        inTime: newShift.StartTime,
                        outTime: newShift.EndTime,
                      },
                    },
                  };
                });
              }
            } catch (err) {
              console.error("Failed to fetch employee shift:", err);
            }
          }
        };

        const handleStatusClick = (optValue: string) => {
          onChange(optValue);
          if (["absent", "leave", "weekoff"].includes(optValue)) {
            setOpen(false);
          }
        };

        const content = (
          <Card size="small" style={{ width: 280, borderRadius: 8 }} bodyStyle={{ padding: 12 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {ATTENDANCE_OPTIONS.map((opt) => {
                const timeForOpt = timeState[cellKey]?.[opt.value] || {};
                const showTimeInputs = opt.value === "present" || opt.value === "half_day";

                return (
                  <div
                    key={opt.value}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      background: value === opt.value ? "#f0faff" : undefined,
                      padding: "4px 6px",
                      borderRadius: 4,
                    }}
                    onClick={() => handleStatusClick(opt.value)}
                  >
                    <span style={{ flex: 1, fontWeight: 500, color: opt.color }}>{opt.label}</span>

                    {showTimeInputs && (
                      <>
                        <input
                          type="time"
                          value={timeForOpt.inTime || ""}
                          onClick={(e) => e.stopPropagation()}
                          style={{ width: 85 }}
                          onChange={(e) =>
                            setTimeState((prev) => ({
                              ...prev,
                              [cellKey]: {
                                ...prev[cellKey],
                                [opt.value]: {
                                  ...prev[cellKey]?.[opt.value],
                                  inTime: e.target.value,
                                },
                              },
                            }))
                          }
                        />
                        <input
                          type="time"
                          value={timeForOpt.outTime || ""}
                          onClick={(e) => e.stopPropagation()}
                          style={{ width: 85 }}
                          onChange={(e) =>
                            setTimeState((prev) => ({
                              ...prev,
                              [cellKey]: {
                                ...prev[cellKey],
                                [opt.value]: {
                                  ...prev[cellKey]?.[opt.value],
                                  outTime: e.target.value,
                                },
                              },
                            }))
                          }
                        />
                      </>
                    )}
                  </div>
                );
              })}

              {shiftData?.StartTime && (
                <div style={{ fontSize: 12, color: "#666", marginTop: 8 }}>
                  <strong>Shift:</strong> {shiftData.StartTime} - {shiftData.EndTime}
                </div>
              )}
            </div>
          </Card>
        );

        return (
          <Popover
            content={content}
            trigger="click"
            open={open}
            onOpenChange={handlePopoverChange}
            placement="bottom"
          >
            <div
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                padding: "2px 6px",
                cursor: "pointer",
                background: "#fff",
                fontSize: 12,
              }}
            >
              {value || "-"}
            </div>
          </Popover>
        );
      }
    );


    useEffect(() => {
      if (!selectedMonth) return;
      const totalDays = dayjs(selectedMonth).daysInMonth();
      const newDays: Day[] = Array.from({ length: totalDays }, (_, i) => {
        const date = dayjs(`${selectedMonth}-${i + 1}`).format("YYYY-MM-DD");
        const dayLabel = dayjs(date).format("ddd");
        return {
          label: i + 1,
          date,
          dayName: dayLabel,
        };
      });
      setDaysInMonth(newDays);
    }, [selectedMonth]);

    const formattedData = useMemo(() => {
      return (attendancelist || []).map((emp: any) => {
        const attendanceMap: Record<string, string> = {};
        if (emp.attendance_status) {
          emp.attendance_status.split(",").forEach((entry: string) => {
            const [date, type] = entry.trim().split(":").map((s) => s.trim());
            if (date && type) {
              attendanceMap[date] = type;
            }
          });
        }

        const leaveFroms = emp.leave_from_dates ? emp.leave_from_dates.split(",").map((d: any) => d.trim()) : [];
        const leaveTos = emp.leave_to_dates ? emp.leave_to_dates.split(",").map((d: any) => d.trim()) : [];

        const leaveDates: string[] = [];
        for (let i = 0; i < leaveFroms.length; i++) {
          const from = dayjs(leaveFroms[i]);
          const to = dayjs(leaveTos[i]);
          const diff = to.diff(from, "day");

          for (let j = 0; j <= diff; j++) {
            leaveDates.push(from.add(j, "day").format("YYYY-MM-DD"));
          }
        }

        return {
          ...emp,
          attendanceMap,
          leave_dates: leaveDates,
        };
      });
    }, [attendancelist]);

    const filteredData = useMemo(() => {
      return formattedData.filter((emp) => {
        const deptMatch = selectedDept ? emp.department === selectedDept : true;
        const projMatch = selectedProject
          ? emp.project?.split(",").map((p: string) => p.trim()).includes(selectedProject)
          : true;
        const empMatch = selectedEmployee ? emp.employee_id === Number(selectedEmployee) : true;

        return deptMatch && projMatch && empMatch;
      });
    }, [formattedData, selectedDept, selectedProject, selectedEmployee]);

    // Apply pagination
    const paginatedData = useMemo(() => {
      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;
      return filteredData.slice(start, end);
    }, [filteredData, currentPage]);

    const filteredDays = useMemo(() => {
      return selectedDay ? daysInMonth.filter((d) => d.date === selectedDay) : daysInMonth;
    }, [daysInMonth, selectedDay]);

    useEffect(() => {
      const newState: { [key: string]: boolean } = {};
      filteredData.forEach((emp) => {
        daysInMonth.forEach((day) => {
          const key = `${emp.employee_id}-${day.date}`;
          newState[key] = (emp.punch_dates ?? []).includes(day.date);
        });
      });
      setCheckedState(newState);
      setOriginalCheckedState(newState);
    }, [filteredData, daysInMonth]);

    return (
      <div style={{ overflowX: "auto", paddingBottom: 20 }}>
        <div style={{ marginBottom: 16 }}>
          <button
            onClick={() => {
              const changedData = Object.entries(attendanceState).map(([key, value]) => {
                const cellTimesForStatus = timeState[key]?.[value] || {};
                const [empId, date] = key.split(/-(.+)/);


                const emp = filteredData.find((e) => e.employee_id === Number(empId));

                return {
                  employee_id: empId,
                  employee_code: emp?.EmployeeCode || "",
                  date,
                  status: value,
                  inTime: cellTimesForStatus.inTime || "",
                  outTime: cellTimesForStatus.outTime || "",
                };
              });


              if (changedData.length > 0) {
                dispatch(createBulkPunchIn(changedData)).then((res: any) => {
                  if (res.meta.requestStatus === "fulfilled") {
                    message.success(res.payload.message);
                  } else {
                    message.warning(res.payload.status);
                  }
                });
              }
            }}
          >
            Save
          </button>
        </div>

        <table style={{ borderCollapse: "collapse", width: "100%", minWidth: "700px" }}>
          <thead>
            <tr>
              <th
                style={{
                  position: "sticky",
                  left: 0,
                  zIndex: 2,
                  background: "#f7f7f7",
                  border: "1px solid #ccc",
                  padding: "8px",
                  minWidth: 150,
                }}
              >
                Employee
              </th>
              {filteredDays.map((day) => (
                <th
                  key={`daynum-${day.date}`}
                  style={{
                    border: "1px solid #ccc",
                    padding: "4px",
                    textAlign: "center",
                    background: "#f1f1f1",
                    fontSize: 11,
                    fontWeight: 600,
                  }}
                >
                  {day.label}
                </th>
              ))}
            </tr>

            <tr>
              <th
                style={{
                  position: "sticky",
                  left: 0,
                  zIndex: 2,
                  background: "#f7f7f7",
                  border: "1px solid #ccc",
                  padding: "8px",
                  minWidth: 150,
                }}
              >
                Day
              </th>
              {filteredDays.map((day) => (
                <th
                  key={`dayname-${day.date}`}
                  style={{
                    border: "1px solid #ccc",
                    padding: "4px",
                    textAlign: "center",
                    background: "#eef",
                    fontSize: 10,
                  }}
                >
                  {day.dayName}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {paginatedData.map((emp) => (
              <tr key={emp.employee_id}>
                <td
                  style={{
                    position: "sticky",
                    left: 0,
                    zIndex: 1,
                    background: "#fff",
                    border: "1px solid #ccc",
                    padding: "8px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {emp.name}
                </td>
                {filteredDays.map((day: any) => (
                  <td
                    key={`${emp.employee_id}-${day.date}`}
                    style={{
                      border: "1px solid #ccc",
                      padding: "2px",
                      textAlign: "center",
                      minWidth: 60,
                    }}
                  >
                    <AttendanceCell
                      empId={emp.employee_id}
                      date={day.date}
                      value={
                        attendanceState[`${emp.employee_id}-${day.date}`] ??
                        emp.attendanceMap?.[day.date]
                      }
                      onChange={(val) => {
                        setAttendanceState((prev) => ({
                          ...prev,
                          [`${emp.employee_id}-${day.date}`]: val,
                        }));
                      }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={filteredData.length}
          onChange={(page) => setCurrentPage(page)}
          style={{ marginTop: 16, textAlign: "right" }}
        />
      </div>
    );
  };



  // Handle file selection
  const handleImportFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      handleCSVImport(file);
      e.target.value = "";
    }
  };

  const handleDateChange = (value: any) => {
    if (value) {
      const formattedDate = dayjs(value).format("YYYY-MM-DD");
      setSelectedDate(formattedDate);
    }
  };
  const disableFutureDates = (current: dayjs.Dayjs) => {
    return current && current > dayjs().endOf("day");
  };

  useEffect(() => {
    dispatch(getEmployeeAttendanceByDate(selectedDate));
    dispatch(fetchAllattendanceReport()).then((res) => {
      setattendacnelist(res.payload.data);
    });
    dispatch(fetchAllProjects());
    dispatch(fetchAllDepartments());
  }, [dispatch, selectedDate]);

  const getModalContainer = () =>
    document.getElementById("modal-datepicker") || document.body;

  const data = employeeAttendanceAnalytics?.data;

  const downloadSampleFormat = [
    {
      EmployeeId: 137,
      PunchDate: "2025-09-23",
      PunchIn: "09:00",
      PunchOut: "17:30",
      PunchType: "IN",
      EmployeeNumber: "003",
      Longitude: 77.4727196,
      Latitude: 28.448938,
      CreatedBy: 124
    }
  ];


  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { AttendanceStatus: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [data, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [employeeAttendanceAnalytics?.data, selectedStatus, selectedSort]);

  const { Option } = Select;



  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [checkedState, setCheckedState] = useState<Record<string, boolean>>({});
  const [viewMode, setViewMode] = useState("day");
  const [selectedDay, setSelectedDay] = useState<string | undefined>();
  const [attendancelist, setattendacnelist] = useState<any[]>([]);
  const { projectsData } = useSelector((state: any) => state.project.projects);

  const handleCheckboxChange = (empId: number, date: string) => {
    const key = `${empId}-${date}`;
    setCheckedState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getDaysInMonth = (month: string) => {
    const [year, monthNum] = month.split("-");
    const daysInMonth = dayjs(`${year}-${monthNum}-01`).daysInMonth();

    return Array.from({ length: daysInMonth }, (_, index) => {
      const date = dayjs(`${year}-${monthNum}-${index + 1}`);
      return {
        date: date.format("YYYY-MM-DD"),
        day: date.format("ddd"),
      };
    });
  };

  const days = selectedMonth ? getDaysInMonth(selectedMonth) : [];

  const monthsOfYear = Array.from({ length: 12 }, (_, i) => {
    const month = dayjs().month(i).format("MM");
    const label = dayjs().month(i).format("MMMM");
    return {
      label,
      value: `${dayjs().year()}-${month}`,
    };
  });

  // const handleSave = () => {
  //   const selectedEntries = Object.entries(checkedState)
  //     .filter(([_, checked]) => checked)
  //     .map(([key]) => {
  //       const [empId, date] = key.split("-");
  //       const employee = dummyEmployees.find(
  //         (emp) => emp.id === parseInt(empId)
  //       );
  //       return {
  //         employee: employee?.name,
  //         date,
  //       };
  //     });

  //   console.log("✅ Checked Attendance:", selectedEntries);
  //   message.success("Attendance saved!");
  // };



  // Name => Department =>check in time => 


  function addTime(t1: string, t2: string) {
    const [h1, m1, s1] = t1.split(":").map(Number);
    const [h2, m2, s2] = t2.split(":").map(Number);
    const total = s1 + s2 + (m1 + m2) * 60 + (h1 + h2) * 3600;
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }


  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img
              src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
              alt="img"
              className="img-fluid rounded-circle"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#">{record.Name}</Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },

    {
      title: "Department Name",
      dataIndex: "DepartmentName",
      sorter: (a: any, b: any) =>
        a.DepartmentName.length - b.DepartmentName.length,
    },

    {
      title: "Check In",
      dataIndex: "PunchIn",
      render: (text: string | null) => (text ? formatTimeOnly(text) : "00"),
      sorter: (a: any, b: any) =>
        (a.PunchIn ?? "").localeCompare(b.PunchIn ?? ""),
    },
    {
      title: "Check-In Image",
      dataIndex: "CheckInImagePath",
      render: (url: string | null) =>
        url ? (
          <Image
            width={60}
            height={60}
            src={url}
            alt="Check-In"
            className="rounded shadow-sm"
            style={{ objectFit: "cover", borderRadius: "8px" }}
          />
        ) : (
          <span className="text-muted">No Image</span>
        ),
    },
    {
      title: "Check-In Location",
      dataIndex: "CheckInAddress",
      render: (text: string | null) => {
        const address = text?.trim() || "No address";

        return (
          <Tooltip title={address} placement="topLeft">
            <div
              style={{
                maxWidth: 150,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: text ? "pointer" : "default",
                color: text ? "#1890ff" : "inherit",
              }}
              onClick={() => text && handleAddressClick(address)}
            >
              {address}
            </div>
          </Tooltip>
        );
      },
    },

    {
      title: "Check Out",
      dataIndex: "PunchOut",
      render: (text: string | null) => (text ? formatTimeOnly(text) : "00"),
      sorter: (a: any, b: any) =>
        (a.PunchOut ?? "").localeCompare(b.PunchOut ?? ""),
    },

    {
      title: "Check-Out Image",
      dataIndex: "CheckOutImagePath",
      render: (url: string | null, record: any) =>
        record.PunchOut && url ? (
          <Image
            width={60}
            height={60}
            src={url}
            alt="Check-Out"
            className="rounded shadow-sm"
            style={{ objectFit: "cover", borderRadius: "8px" }}
          />
        ) : (
          <span className="text-muted">-</span>
        ),
    },

    {
      title: "Status",
      dataIndex: "AttendanceStatus",
      render: (text: String, record: any) => (
        <span
          className={`badge ${text === "Present"
            ? "badge-success-transparent"
            : "badge-danger-transparent"
            } d-inline-flex align-items-center`}
        >
          <i className="ti ti-point-filled me-1" />
          {record.AttendanceStatus}
        </span>
      )
    },

    {
      title: "Break Time",
      dataIndex: "breaks",
      render: (breaks: any[]) => {
        if (!breaks || breaks.length === 0)
          return <span className="text-muted">00:00:00</span>;

        // Sum all break durations
        let total = "00:00:00";
        if (breaks.length === 1) {
          total = breaks[0].breakDuration;
        } else {
          total = breaks.reduce((a, b) => addTime(a.breakDuration || a, b.breakDuration));
        }

        return (
          <span className="badge badge-warning-transparent d-inline-flex align-items-center">
            <i className="ti ti-clock-pause me-1"></i>
            {total}
          </span>
        );
      }
    },

    {
      title: "Late Login",
      dataIndex: "lateLogin",
      render: (time: string) => (
        <span className="badge badge-danger-transparent d-inline-flex align-items-center">
          <i className="ti ti-clock-hour-3 me-1"></i>
          {time ?? "00:00:00"}
        </span>
      )
    },

    {
      title: "Overtime",
      dataIndex: "overtime",
      render: (time: string) => (
        <span className="badge badge-success-transparent d-inline-flex align-items-center">
          <i className="ti ti-clock-hour-9 me-1"></i>
          {time ?? "00:00:00"}
        </span>
      )
    },

    {
      title: "Productive Hours",
      dataIndex: "Duration",
      render: (text: string | null, record: any) => {
        const duration = record.Duration ?? "00";
        const durationNum = parseFloat(duration) || 0;

        const badgeClass =
          durationNum < 8
            ? "badge-danger"
            : durationNum >= 8 && durationNum <= 9
              ? "badge-success"
              : "badge-info";

        return (
          <span className={`badge d-inline-flex align-items-center badge-sm ${badgeClass}`}>
            <i className="ti ti-clock-hour-11 me-1"></i>
            {duration}
          </span>
        );
      },
      sorter: (a: any, b: any) => {
        const aDur = parseFloat(a.Duration ?? "0");
        const bDur = parseFloat(b.Duration ?? "0");
        return aDur - bDur;
      },
    },

    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) =>
        record.locationTracking === 1 && record.AttendanceStatus == "Present" ? (
          <Button
            type="primary"
            icon={<EnvironmentOutlined />}
            onClick={() => handleViewRoute(record)}
          >
            View Route
          </Button>
        ) : null
    }
  ];


  const statusChoose = [
    { value: "Select", label: "Select" },
    { value: "Present", label: "Present" },
    { value: "Absent", label: "Absent" },
  ];

  const getModalContainer2 = () => {
    const modalElement = document.getElementById("modal_datepicker");
    return modalElement ? modalElement : document.body;
  };

  return (
    <>

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Attendance Admin</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Attendance Admin
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                  {/* <Link
                    to={all_routes.attendanceemployee}
                    className="btn btn-icon btn-sm  me-1"
                  >
                    <i className="ti ti-brand-days-counter" />
                  </Link> */}
                  {/* <Link
                    to={all_routes.attendanceadmin}
                    className="btn btn-icon btn-sm active bg-primary text-white"
                  >
                    <i className="ti ti-calendar-event" />
                  </Link> */}
                </div>
              </div>
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Import
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <button
                        type="button"
                        onClick={triggerImportFileSelect}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-spreadsheet me-1" />
                        Import as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => setShowSampleModal(true)}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-eye me-1" />
                        View Sample Format
                      </button>
                    </li>
                  </ul>
                </div>

                {/* Hidden file input */}
                <input
                  type="file"
                  accept=".csv"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleImportFileChange}
                />
              </div>
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data, "Admin_attendance")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data, "Admin_attendance")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToPDF(data, "Admin_attendance")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as PDF{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-2 me-2">
                <button
                  type="button"
                  className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  onClick={handleOpenDrawer}
                  disabled={isOpening}   // disable when loading
                >
                  {isOpening ? (
                    <span className="spinner-border spinner-border-sm me-2" />
                  ) : (
                    <i className="ti ti-file-analytics me-1" />
                  )}
                  Manually
                </button>

              </div>

              {/* <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary d-flex align-items-center"
                  data-bs-target="#attendance_report"
                  data-bs-toggle="modal"
                  data-inert={true}
                >
                  <i className="ti ti-file-analytics me-2" />
                  
                </Link>
              </div> */}

              <div
                className="position-relative d-inline-block "
                style={{ width: 160 }}
              >
                <i
                  className="ti ti-file-analytics text-white position-absolute"
                  style={{
                    left: 5,
                    top: "40%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                  }}
                />
                <DatePicker
                  className="form-control border-0 ps-4 bg-primary text-white shadow-none"
                  format={{
                    format: "DD-MM-YYYY",
                    type: "mask",
                  }}
                  getPopupContainer={getModalContainer}
                  placeholder="DD-MM-YYYY"
                  onChange={handleDateChange}
                  disabledDate={disableFutureDates}
                  value={dayjs(selectedDate)}
                  style={{ width: "100%" }}
                />
              </div>

              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <AttendanceSummaryCard
              title="Total Employees"
              value={employeeAttendanceAnalytics?.analytics.totalEmployees}
              iconClass="ti ti-users fs-18 text-primary"
              bgClass="bg-primary-transparent border border-primary"
            />
            <AttendanceSummaryCard
              title="Present Employees"
              value={employeeAttendanceAnalytics?.analytics.totalPresent}
              iconClass="ti ti-circle-check fs-18 text-success"
              bgClass="bg-success-transparent border border-success"
            />
            <AttendanceSummaryCard
              title="Absent Employees"
              value={employeeAttendanceAnalytics?.analytics.totalAbsent}
              iconClass="ti ti-circle-x fs-18 text-danger"
              bgClass="bg-danger-transparent border border-danger"
            />
            <AttendanceSummaryCard
              title="Work From Home"
              value={employeeAttendanceAnalytics?.analytics.totalWorkFromHome}
              iconClass="ti ti-home fs-18 text-info"
              bgClass="bg-info-transparent border border-info"
            />
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Admin Attendance</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Present")}
                        className="dropdown-item rounded-1"
                      >
                        Present
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Absent")}
                        className="dropdown-item rounded-1"
                      >
                        Absent
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Edit Attendance */}
      <div className="modal fade" id="edit_attendance">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Attendance</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Date</label>
                      <div className="input-icon input-icon-new position-relative w-100 me-2">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{
                            format: "DD-MM-YYYY",
                            type: "mask",
                          }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Check In</label>
                      <div className="input-icon input-icon-new position-relative w-100">
                        <TimePicker
                          getPopupContainer={getModalContainer2}
                          use12Hours
                          placeholder="Choose"
                          format="h:mm A"
                          className="form-control timepicker"
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-clock-hour-3" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Check Out</label>
                      <div className="input-icon input-icon-new position-relative w-100">
                        <TimePicker
                          getPopupContainer={getModalContainer2}
                          use12Hours
                          placeholder="Choose"
                          format="h:mm A"
                          className="form-control timepicker"
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-clock-hour-3" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Break</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue="30 Min	"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Late</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue="32 Min"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Production Hours</label>
                      <div className="input-icon input-icon-new position-relative w-100">
                        <TimePicker
                          getPopupContainer={getModalContainer2}
                          use12Hours
                          placeholder="Choose"
                          format="h:mm A"
                          className="form-control timepicker"
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-clock-hour-3" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3 ">
                      <label className="form-label">Status</label>
                      <CommonSelect
                        className="select"
                        options={statusChoose}
                        defaultValue={statusChoose[1]}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Attendance */}
      {/* Attendance Report */}
      <div className="modal fade" id="attendance_report">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Attendance</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="card shadow-none bg-transparent-light">
                <div className="card-body pb-1">
                  <div className="row align-items-center">
                    <div className="col-lg-4">
                      <div className="d-flex align-items-center mb-3">
                        <span className="avatar avatar-sm avatar-rounded flex-shrink-0 me-2">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-02.jpg"
                            alt="Img"
                          />
                        </span>
                        <div>
                          <h6 className="fw-medium">Anthony Lewis</h6>
                          <span>UI/UX Team</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="mb-3 text-sm-end">
                            <span>Date</span>
                            <p className="text-gray-9 fw-medium">15 Apr 2025</p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-3 text-sm-end">
                            <span>Punch in at</span>
                            <p className="text-gray-9 fw-medium">09:00 AM</p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-3 text-sm-end">
                            <span>Punch out at</span>
                            <p className="text-gray-9 fw-medium">06:45 PM</p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="mb-3 text-sm-end">
                            <span>Status</span>
                            <p className="text-gray-9 fw-medium">Present</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card shadow-none border mb-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3">
                      <div className="mb-4">
                        <p className="d-flex align-items-center mb-1">
                          <i className="ti ti-point-filled text-dark-transparent me-1" />
                          Total Working hours
                        </p>
                        <h3>12h 36m</h3>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="mb-4">
                        <p className="d-flex align-items-center mb-1">
                          <i className="ti ti-point-filled text-success me-1" />
                          Productive Hours
                        </p>
                        <h3>08h 36m</h3>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="mb-4">
                        <p className="d-flex align-items-center mb-1">
                          <i className="ti ti-point-filled text-warning me-1" />
                          Break hours
                        </p>
                        <h3>22m 15s</h3>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="mb-4">
                        <p className="d-flex align-items-center mb-1">
                          <i className="ti ti-point-filled text-info me-1" />
                          Overtime
                        </p>
                        <h3>02h 15m</h3>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8 mx-auto">
                      <div
                        className="progress bg-transparent-dark mb-3"
                        style={{ height: 24 }}
                      >
                        <div
                          className="progress-bar bg-success rounded me-2"
                          role="progressbar"
                          style={{ width: "18%" }}
                        />
                        <div
                          className="progress-bar bg-warning rounded me-2"
                          role="progressbar"
                          style={{ width: "5%" }}
                        />
                        <div
                          className="progress-bar bg-success rounded me-2"
                          role="progressbar"
                          style={{ width: "28%" }}
                        />
                        <div
                          className="progress-bar bg-warning rounded me-2"
                          role="progressbar"
                          style={{ width: "17%" }}
                        />
                        <div
                          className="progress-bar bg-success rounded me-2"
                          role="progressbar"
                          style={{ width: "22%" }}
                        />
                        <div
                          className="progress-bar bg-warning rounded me-2"
                          role="progressbar"
                          style={{ width: "5%" }}
                        />
                        <div
                          className="progress-bar bg-info rounded me-2"
                          role="progressbar"
                          style={{ width: "3%" }}
                        />
                        <div
                          className="progress-bar bg-info rounded"
                          role="progressbar"
                          style={{ width: "2%" }}
                        />
                      </div>
                    </div>
                    <div className="co-md-12">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fs-10">06:00</span>
                        <span className="fs-10">07:00</span>
                        <span className="fs-10">08:00</span>
                        <span className="fs-10">09:00</span>
                        <span className="fs-10">10:00</span>
                        <span className="fs-10">11:00</span>
                        <span className="fs-10">12:00</span>
                        <span className="fs-10">01:00</span>
                        <span className="fs-10">02:00</span>
                        <span className="fs-10">03:00</span>
                        <span className="fs-10">04:00</span>
                        <span className="fs-10">05:00</span>
                        <span className="fs-10">06:00</span>
                        <span className="fs-10">07:00</span>
                        <span className="fs-10">08:00</span>
                        <span className="fs-10">09:00</span>
                        <span className="fs-10">10:00</span>
                        <span className="fs-10">11:00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Attendance Report */}

      <Modal
        open={showSampleModal}
        onCancel={() => setShowSampleModal(false)}
        footer={null}
        centered
        width={700}
      >
        <div className="position-relative">
          <div
            className="position-absolute"
            style={{ top: -4, right: 27, zIndex: 2 }}
          >
            <button
              className="btn btn-sm btn-primary"
              onClick={() => exportToCSV(downloadSampleFormat, "attendance_sample")}
            >
              <i className="ti ti-download me-1" />
              <span className="d-none d-sm-inline">Download Sample CSV</span>
            </button>
          </div>
          <div
            style={{
              overflowX: "auto",
              maxHeight: "60vh",
              paddingTop: "2rem",
              paddingBottom: "1rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
            }}
          >
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>EmployeeId</th>
                  <th>PunchDate</th>
                  <th>PunchTime</th>
                  <th>PunchOut</th>
                  <th>PunchType</th>
                  <th>EmployeeCode</th>
                  <th>Longitude</th>
                  <th>Latitude</th>
                  <th>CreatedBy</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>137</td>
                  <td>2025-07-22</td>
                  <td>09:00</td>
                  <td>17:30</td>
                  <td>IN</td>
                  <td>EMP003</td>
                  <td>77.4727196</td>
                  <td>28.448938</td>
                  <td>124</td>
                </tr>
                <tr>
                  <td>138</td>
                  <td>2025-07-22</td>
                  <td>10:15</td>
                  <td>18:45</td>
                  <td>IN</td>
                  <td>EMP004</td>
                  <td>77.498325</td>
                  <td>28.501112</td>
                  <td>124</td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </Modal>

      <Drawer
        title="Attendance"
        width={1050}
        onClose={() => {
          setIsDrawerOpen(false);
          setIsOpening(false);
        }
        }
        open={isDrawerOpen}
        extra={
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            {/* Legend Items */}
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <span
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: "#4CAF50", // Present
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    display: "inline-block",
                  }}
                />
                <span>Present</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <span
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: "#F44336",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    display: "inline-block",
                  }}
                />
                <span>Absent</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <span
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: "#FF9800",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    display: "inline-block",
                  }}
                />
                <span>Leave</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <span
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: "#2196F3",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    display: "inline-block",
                  }}
                />
                <span>Half_Day</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <span
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: "#9C27B0",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    display: "inline-block",
                  }}
                />
                <span>Week Off</span>
              </div>
            </div>
          </div>
        }
      >
        {/* Month Picker */}
        <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
          <Col>
            <Select
              placeholder="Department"
              allowClear
              value={selectedDept}
              onChange={setSelectedDept}
              style={{ width: 150 }}
            >
              {departments.map((dept: any) => (
                <Option key={dept.Id} value={dept.Name}>
                  {dept.Name}
                </Option>
              ))}
            </Select>
          </Col>

          <Col>
            <Select
              placeholder="Project"
              allowClear
              value={selectedProject}
              onChange={setSelectedProject}
              style={{ width: 150 }}
            >
              {projectsData.map((proj: any) => (
                <Option key={proj.project_id} value={proj.project_name}>
                  {proj.project_name}
                </Option>
              ))}
            </Select>
          </Col>

          <Col>
            <Select
              placeholder="Employee"
              allowClear
              value={selectedEmployee ?? undefined}
              onChange={setSelectedEmployee}
              style={{ width: 160 }}
            >
              {attendancelist?.map((emp: any) => (
                <Select.Option
                  key={emp.employee_id}
                  value={String(emp.employee_id)}
                >
                  {emp.name}
                </Select.Option>
              ))}
            </Select>
          </Col>

          <Col>
            <Select
              placeholder="Month"
              value={selectedMonth}
              onChange={setSelectedMonth}
              style={{ width: 120 }}
            >
              {monthsOfYear.map((month) => (
                <Option key={month.value} value={month.value}>
                  {month.label}
                </Option>
              ))}
            </Select>
          </Col>

          <Col>
            <Select
              placeholder="Day"
              allowClear
              value={selectedDay}
              onChange={setSelectedDay}
              style={{ width: 120 }}
              disabled={!selectedMonth}
            >
              {Array.from(
                { length: dayjs(selectedMonth).daysInMonth() },
                (_, i) => {
                  const date = dayjs(`${selectedMonth}-${i + 1}`).format("YYYY-MM-DD");
                  const label = `${i + 1} (${dayjs(date).format("ddd")})`;
                  return (
                    <Option key={date} value={date}>
                      {label}
                    </Option>
                  );
                }
              )}
            </Select>
          </Col>

          <Col>
            <Button
              type="primary"
              loading={isBuilding}
              onClick={handleBuildAttendance}
            >
              Build Attendance
            </Button>

          </Col>
        </Row>


        {/* Main Attendance Grid */}
        <CustomAttendanceTable
          attendancelist={attendancelist}
          selectedMonth={selectedMonth}
          selectedDept={selectedDept}
          selectedProject={selectedProject}
          selectedDay={selectedDay}
          selectedEmployee={selectedEmployee}
        />
      </Drawer>
      <RouteMapModal
        isOpen={isMapModalOpen}
        onClose={() => {
          setIsMapModalOpen(false);
          window.location.reload();
        }}
        route={employeeRoute}
        isMapLoaded={isLoaded}
      />
      <Modal
        title="Check-In Address"
        open={isAddressModalVisible}
        onCancel={handleAddressModalClose}
        footer={null}
        centered
      >
        <p style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
          {selectedAddress}
        </p>
      </Modal>

    </>
  );
};

export default AttendanceAdmin;
